
















































































/* Created- 20 - May - 2019 */
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { ParticaEvent, getActionName, eParticaAction } from "../../Models/ParticaEvent";
import ParticaView from "@/Ui-Components/Common/ParticaView.vue";
import ParticaAdminBase from "../Base/ParticaAdminBase.vue";
import ParticaCardXl from "@/Ui-Components/Common/Container/ParticaCardMax.vue";
import ParticaCard from "@/Ui-Components/Common/Container/ParticaCardFill.vue";
import { ButtonConfig, ButtonType } from "../../Models/Buttons";
import ButtonList from "@/Ui-Components/Common/Buttons/ButtonList.vue";
import { ArticleOwnerPaymentDTO, ContentStreamArticleOwnerBatchDTO, ContentStreamArticleOwnerBatchItemDTO, ContentStreamArticleOwnerBatchDTOStatus } from "../../Generated/ParticaAPI";
import { IContentStreamPaymentService } from "../../BusinessServices/contentstreampayment";
import StreamOwnerPayments from "@/Ui-Components/Account/StreamOwnerPayments.vue";
import StreamOwnerBatches from "@/Ui-Components/Account/StreamOwnerBatches.vue";
import ParticaRightDrawer from "@/Ui-Components/Common/Container/ParticaRightDrawer.vue";
import StreamOwnerBatchItems from "@/Ui-Components/Account/StreamOwnerBatchItems.vue";


@Component(
	{
		name: "AdminStreamOwnerPayments",
		components: {
			ParticaView,
			ParticaCardXl,
			ParticaCard,
			StreamOwnerPayments,
			ButtonList,
			StreamOwnerBatches,
			ParticaRightDrawer,
			StreamOwnerBatchItems
		}
	})
export default class AdminStreamOwnerPayments extends ParticaAdminBase {
	private service: IContentStreamPaymentService;
	private data: ArticleOwnerPaymentDTO[] = [];
	private createbatchbuttons: ButtonConfig[] = [
		{ label: "Create Batch", action: eParticaAction.CONTENT_STREAM_CREATE_BATCH, type: ButtonType.OK } as ButtonConfig
	];
	private paybuttons: ButtonConfig[] = [
		{ label: "Pay Owners", action: eParticaAction.CONTENT_STREAM_SEND_OWNER_PAYMENTS, type: ButtonType.OK } as ButtonConfig
	];
	private outstandingMonths: string[] = [];
	private month: string = "";
	private batches: ContentStreamArticleOwnerBatchDTO[] = [];
	private batch: ContentStreamArticleOwnerBatchDTO = new ContentStreamArticleOwnerBatchDTO();
	private showbatch: boolean = false;
	private batchitems: ContentStreamArticleOwnerBatchItemDTO[] = [];

	private isBatchPaid(batch: ContentStreamArticleOwnerBatchDTO): boolean {
		if (batch.status === ContentStreamArticleOwnerBatchDTOStatus.FundsDeposited) {
			return true;
		}
		return false;
	}

	private getBatchTotal(): number {
		let total: number = 0;
		this.batchitems.forEach(x => { total += x.amount as number; });
		return total;
	}


	private async eventHandler(event: ParticaEvent) {
		try {
			this.LoadingStart();
			switch (event.action) {
				case eParticaAction.CONTENT_STREAM_CREATE_BATCH: {
					await this.service.CreateOwnerBatch(this.month);
					await this.init(); // reload
					break;
				}
				case eParticaAction.CONTENT_STREAM_SHOW_BATCH: {
					this.batch = event.item;
					this.batchitems = await this.service.GetOwnerBatchItems(this.batch.id as number);
					this.showbatch = true;
					break;
				}
				case eParticaAction.CONTENT_STREAM_SEND_OWNER_PAYMENTS: {
					await this.service.PayArticeOwners(this.batch.id as number);
					this.showbatch = false;
					await this.init(); // reload
					break;
				}
				default: {
					this.baseEventHandler(event);
				}

			}
		} catch (error) {
			this.ShowErrorDialog(error, `Unhandled event. ${getActionName(event.action)}`);
		} finally {
			this.LoadingEnd();
		}
	}



	@Watch("$route")
	private async change(to: any, from: any) {
		await this.init();
	}
	private async mounted() {
		this.metadata.name = "Article Owner Payments";
		this.service = this.particaServices.getContentStreampaymentService();
		this.init();
	}

	private async init() {
		try {
			this.LoadingStart();
			await this.getAdminNav(0);
			this.data = await this.service.GetOutstandingOwner();
			this.outstandingMonths = await this.service.GetAvailableOwnerMonths();
			this.batches = await this.service.GetOwnerBatches();
		} catch (error) {
			this.ShowErrorDialog(error, "error initializing component.");
		} finally {
			this.LoadingEnd();
		}
	}
}
